import { Configuration, LogLevel } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || '';
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || '';

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginScopes = {
  scopes: ['openid', 'profile', 'email'],
};

export const apiScopes = {
  scopes: [`api://${clientId}/access_as_user`],
};

// Fallback scopes using client ID directly (works without "Expose an API" configured)
export const apiScopesFallback = {
  scopes: [`${clientId}/.default`],
};
